export enum PersonSex {
  All = '',
  Male = 'm',
  Female = 'f',
}
